module.exports = __webpack_public_path__ + "img/custom-02.83b2af2e.jpg";